import { Scene, Vector3, AbstractMesh, PBRMaterial, Color3, ActionManager, ExecuteCodeAction } from '@babylonjs/core';
import { SceneLoader } from '@babylonjs/core/Loading/sceneLoader';
import { TORUS_POSITION, TORUS_SCALE, SUPABASE_STORAGE_ROOT, TORUS_COLORS } from '../utils/constants';

const TORUS_URL = `${SUPABASE_STORAGE_ROOT}meshes/Torus.glb`;

function createIridescentGlass(scene: Scene): PBRMaterial {
  const pbr = new PBRMaterial('IridescentGlass', scene);
  pbr.metallic = 0.0;
  pbr.roughness = 0.05;
  pbr.alpha = 0.6;
  pbr.indexOfRefraction = 1.25;

  pbr.refractionTexture = scene.environmentTexture;
  if (pbr.refractionTexture) {
    pbr.refractionTexture.level = 1.3;
    pbr.refractionTexture.invertZ = true;
  }

  pbr.reflectivityColor = new Color3(0.9, 0.9, 0.9);

  // Set initial emissive color for state transitions (idle = cyan)
  pbr.emissiveColor = new Color3(TORUS_COLORS.idle.r, TORUS_COLORS.idle.g, TORUS_COLORS.idle.b);

  pbr.iridescence.isEnabled = true;
  pbr.iridescence.intensity = 1.0;
  pbr.iridescence.minimumThickness = 50.0;
  pbr.iridescence.maximumThickness = 400.0;

  pbr.clearCoat.isEnabled = true;
  pbr.clearCoat.intensity = 0.8;
  pbr.clearCoat.indexOfRefraction = 1.5;

  pbr.subSurface.isRefractionEnabled = true;
  pbr.subSurface.indexOfRefraction = 1.25;

  return pbr;
}

export async function createTorus(
  scene: Scene,
  onPick?: (mesh: AbstractMesh) => void
): Promise<AbstractMesh> {
  const result = await SceneLoader.ImportMeshAsync('', TORUS_URL, '', scene);

  const root = result.meshes[0];
  root.name = 'hollaSphere';
  root.position = new Vector3(
    TORUS_POSITION.x,
    TORUS_POSITION.y,
    TORUS_POSITION.z
  );
  root.scaling = new Vector3(TORUS_SCALE, TORUS_SCALE, TORUS_SCALE);

  // Apply iridescent glass material and make clickable
  const material = createIridescentGlass(scene);
  for (const mesh of result.meshes) {
    if (mesh !== root) {
      mesh.material = material;
      mesh.isPickable = true;
      mesh.actionManager = new ActionManager(scene);
      mesh.actionManager.registerAction(
        new ExecuteCodeAction(ActionManager.OnPickTrigger, () => {
          if (onPick) {
            onPick(root);
          }
        })
      );
    }
  }

  return root;
}
